import React, { useState, useEffect } from 'react';
import Icon from 'react-icons-kit';
import { x } from 'react-icons-kit/oct/x';
import { clipboard } from 'react-icons-kit/icomoon/clipboard'
import { ic_content_copy } from 'react-icons-kit/md/ic_content_copy';

interface TProps {
    value: string;
    title: string;
}

const ClipButton: React.FC<TProps> = ({ value, title }) => {
    const [isSuccessful, setIsSuccessful] = useState<boolean>(false);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        if (isSuccessful || error) {
            setTimeout(() => {
                setIsSuccessful(false);
                setError(null);
            }, 1500);
        }
    }, [isSuccessful, error]);

    const clip = async () => {
        if (!isSuccessful && !error) {
            try {
                await navigator.clipboard.writeText(value);
                setIsSuccessful(true);
            } catch (err) {
                console.error('Failed to copy text: ', err);
                setError(err)
            }
        }
    }

    let icon = ic_content_copy;
    let color: string = 'blue'

    if (isSuccessful) {
        icon = clipboard;
        color = 'green'
    }

    if (error) {
        icon = x
        color = 'red'
    }

    return (
        <span onClick={clip} title={title} >
            <Icon icon={icon} style={{ color: color, cursor: 'pointer' }} />
        </span>
    );
};

export default ClipButton;